import {
  AlertTriangle,
  FileEdit,
  FolderOpen,
  Clock,
  CheckCircle2,
  Archive,
} from "lucide-react";

export function SnagStatsCards({ snags = [] }) {
  let draft = 0;
  let open = 0;
  let pending = 0;
  let resolved = 0;
  let closed = 0;
  let overdue = 0;

  const now = new Date();

  /* -------- Single loop (optimized) -------- */
  snags.forEach((s) => {
    switch (s.status) {
      case "Draft":
        draft++;
        break;
      case "Open":
        open++;
        break;
      case "Pending Approval":
        pending++;
        break;
      case "Resolved":
        resolved++;
        break;
      case "Closed":
        closed++;
        break;
      default:
        break;
    }

    /* -------- Safe overdue check -------- */
    if (s.expectedClosure && !["Closed", "Resolved"].includes(s.status)) {
      const date = new Date(s.expectedClosure);
      if (!isNaN(date) && date < now) {
        overdue++;
      }
    }
  });

  const total = snags.length;

  const closureRate =
    total > 0 ? Math.round(((resolved + closed) / total) * 100) : 0;

  const stats = [
    {
      label: "Total",
      value: total,
      icon: Archive,
      color: "text-primary-text",
      bg: "bg-sm-card",
    },
    {
      label: "Draft",
      value: draft,
      icon: FileEdit,
      color: "text-text-gray",
      bg: "bg-gray-bg",
    },
    {
      label: "Open",
      value: open,
      icon: FolderOpen,
      color: "text-sm-primary",
      bg: "bg-sm-primary/10",
    },
    {
      label: "Pending",
      value: pending,
      icon: Clock,
      color: "text-sm-accent",
      bg: "bg-task-hover",
    },
    {
      label: "Resolved",
      value: resolved,
      icon: CheckCircle2,
      color: "text-green-600",
      bg: "bg-[#EBFDF5]",
    },
    {
      label: "Closed",
      value: closed,
      icon: CheckCircle2,
      color: "text-green-600",
      bg: "bg-[#EBFDF5]",
    },
    {
      label: "Overdue",
      value: overdue,
      icon: AlertTriangle,
      color: "text-red-600",
      bg: "bg-red-100",
    },
  ];

  return (
    <div className="space-y-4">
      {/* Cards */}
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-7">
        {stats.map((s) => (
          <div
            key={s.label}
            className={`rounded-xl border px-6 py-3 flex flex-col gap-2 ${s.bg}`}
          >
            <div className="flex items-center gap-2">
              <s.icon className={`h-4 w-4 ${s.color}`} />
              <span className="text-xs font-semibold uppercase text-gray-500">
                {s.label}
              </span>
            </div>

            <span className={`text-2xl font-semibold ${s.color}`}>{s.value}</span>
          </div>
        ))}
      </div>

      {/* Closure Rate */}
      <div className="flex items-center gap-3 px-1">
        <span className="text-sm text-gray-500">Closure Rate</span>

        <div className="h-2.5 flex-1 rounded-full bg-gray-200 overflow-hidden">
          <div
            className="h-full bg-sm-primary transition-all"
            style={{ width: `${closureRate}%` }}
          />
        </div>

        <span className="text-sm font-semibold text-sm-primary">
          {closureRate}%
        </span>
      </div>
    </div>
  );
}
